import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=2c5e495c&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=ts"
export * from "./Photos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e495c",
  null
  
)

export default component.exports